import React, { useState } from "react";
import OrdersRow from "./OrdersRow";
import PacmanLoader from "react-spinners/PacmanLoader";
import { ClipLoader } from "react-spinners";
import RecordNotFound from "./RecordNotFound";
import FetchingError from "./FetchingError";

const OrderTable = ({
  orders = [],
  onViewOrder,
  orderStatusFilter = null,
  columnNames = {
    orderId: "Order ID",
    subject: "Subject",
    price: "Price",
    orderStatus: "Order Status",
    created: "Created",
    dueDate: "Due Date",
    actions: "Actions",
  },
  buttonText = "View Order", // Default button text
  secondaryButtonText,
  onSecondaryViewOrder,
  onDeleteDraft,
  loading,
  tableName,
  onRetry,
  error,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedFullPreview, setSelectedFullPreview] = useState("");

  return (
    <div className="relative font-inter flex flex-col min-h-[400px] flex-grow items-center">
      <div className={`${orders.length !== 0 && !loading ? 'border border-medium-gray ' : 'border-none'} rounded-[10px] max-h-[480px] w-full overflow-auto scrollbar-thin`}>
        <table className="w-full min-w-[760px] border-collapse divide-y divide-medium-gray text-[13px]">
          <thead>
            <tr className="h-[52px] text-[13px] text-secondary leading-5 font-semibold sticky top-0 bg-soft-gray">
              <th className="px-3 text-left">{columnNames.orderId}</th>
              <th className="px-3 text-left">
                {columnNames.subject}
              </th>
              <th className="px-3 text-left whitespace-nowrap">{columnNames.price}</th>
              <th className="px-3 text-left">{columnNames.orderStatus}</th>
              <th className="px-3 text-left">{columnNames.created}</th>
              <th className="px-3 text-left whitespace-nowrap">{columnNames.dueDate}</th>
              <th className="px-3 text-left whitespace-nowrap">{columnNames.actions}</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-medium-gray text-[13px]">
            {loading ? (
              <tr>
                <td colSpan="9" className="text-center py-8">
                  {/* <div className="flex justify-center">
                    <PacmanLoader color="#60a5fa" loading={loading} size={15} />
                  </div> */}
                </td>
              </tr>
            ) : (error || orders?.length === 0) ?
              (
                <tr>
                 <td colSpan="9" className="text-center py-8">
                  <FetchingError 
                    error={error} 
                    isEmptyRecords={orders.length === 0} 
                    onRetry={onRetry}
                  /> 
                 </td>
                </tr>
              )
              :
            // orders.length === 0 ? (
            //   <tr>
            //     <td colSpan="9" className="text-center py-8">
            //       <RecordNotFound
            //         message="No Order found"
            //         onRetry={onRetry}
            //       />
            //     </td>
            //   </tr>
            // ) : 
            (
              orders.map((order, index) => (
                <OrdersRow
                  key={index}
                  order={order}
                  onViewOrder={onViewOrder}
                  setSelectedFullPreview={setSelectedFullPreview}
                  setOpenModal={setOpenModal}
                  buttonText={buttonText}
                  secondaryButtonText={secondaryButtonText}
                  onSecondaryViewOrder={onSecondaryViewOrder}
                  onDeleteDraft={onDeleteDraft}
                  tableName={tableName}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
      {loading &&
        <div className="flex flex-col flex-grow justify-center items-center w-full h-[100%]">
          <ClipLoader color="#60a5fa" loading={loading} size={44} speedMultiplier={0.5}/>
        </div>
      }
    </div>
  );
};

export default OrderTable;
